var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_7719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 2.28369H2.70833C2.1125 2.28369 1.625 2.77119 1.625 3.36702V10.9504C1.625 11.5462 2.1125 12.0337 2.70833 12.0337H10.2917C10.8875 12.0337 11.375 11.5462 11.375 10.9504V3.36702C11.375 2.77119 10.8875 2.28369 10.2917 2.28369ZM4.875 9.86702H3.79167V6.07536H4.875V9.86702ZM7.04167 9.86702H5.95833V4.45036H7.04167V9.86702ZM9.20833 9.86702H8.125V7.70036H9.20833V9.86702Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_7719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.658691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.2b0c5aaf3a516ec5ced091e29bb7b067.svg";
export { ForwardRef as ReactComponent };